/**
 * ⬆️ UPGRADES
 * 
 * Permanent production multipliers that can be purchased.
 * These provide percentage boosts to specific resource production.
 */

export const upgrades = {
  betterAxes: {
    id: 'betterAxes',
    name: 'Better Axes',
    icon: '🪓',
    description: '+25% wood production',
    cost: { gold: 100, iron: 50 },
    effect: { resource: 'wood', multiplier: 1.25 },
    requires: { tech: 'blacksmithing' },
  },

  reinforcedPickaxes: {
    id: 'reinforcedPickaxes',
    name: 'Reinforced Pickaxes',
    icon: '⛏️',
    description: '+25% stone production',
    cost: { gold: 100, iron: 50 },
    effect: { resource: 'stone', multiplier: 1.25 },
    requires: { tech: 'blacksmithing' },
  },

  irrigation: {
    id: 'irrigation',
    name: 'Irrigation Systems',
    icon: '💧',
    description: '+50% food production',
    cost: { gold: 200, stone: 100 },
    effect: { resource: 'food', multiplier: 1.50 },
    requires: { tech: 'engineering' },
  },

  tradingAgreements: {
    id: 'tradingAgreements',
    name: 'Trading Agreements',
    icon: '🤝',
    description: '+30% gold production',
    cost: { gold: 500, knowledge: 100 },
    effect: { resource: 'gold', multiplier: 1.30 },
    requires: { tech: 'commerce' },
  },

  advancedSmelting: {
    id: 'advancedSmelting',
    name: 'Advanced Smelting',
    icon: '🔥',
    description: '+40% iron production',
    cost: { gold: 300, coal: 100 },
    effect: { resource: 'iron', multiplier: 1.40 },
    requires: { tech: 'smelting' },
  },

  scholarship: {
    id: 'scholarship',
    name: 'Scholarship Programs',
    icon: '📚',
    description: '+35% knowledge production',
    cost: { gold: 400, culture: 50 },
    effect: { resource: 'knowledge', multiplier: 1.35 },
    requires: { tech: 'education' },
  },

  culturalRenaissance: {
    id: 'culturalRenaissance',
    name: 'Cultural Renaissance',
    icon: '🎭',
    description: '+50% culture production',
    cost: { gold: 600, knowledge: 150 },
    effect: { resource: 'culture', multiplier: 1.50 },
    requires: { tech: 'arts' },
  },

  masterCrafting: {
    id: 'masterCrafting',
    name: 'Master Crafting',
    icon: '⚒️',
    description: '+45% tools production',
    cost: { gold: 500, steel: 100 },
    effect: { resource: 'tools', multiplier: 1.45 },
    requires: { tech: 'engineering' },
  },

  magicalInfusion: {
    id: 'magicalInfusion',
    name: 'Magical Infusion',
    icon: '✨',
    description: '+60% magic production',
    cost: { gems: 200, knowledge: 300 },
    effect: { resource: 'magic', multiplier: 1.60 },
    requires: { tech: 'enchanting' },
  },

  scientificMethod: {
    id: 'scientificMethod',
    name: 'Scientific Grants',
    icon: '🔬',
    description: '+40% science production',
    cost: { gold: 800, knowledge: 200 },
    effect: { resource: 'science', multiplier: 1.40 },
    requires: { tech: 'scientific_method' },
  },
};

// === HELPER FUNCTIONS ===

export const getUpgradeCount = () =>
  Object.keys(upgrades).length;

export const getAvailableUpgrades = (researchedTechs, purchasedUpgrades) =>
  Object.values(upgrades).filter(upgrade =>
    !purchasedUpgrades.includes(upgrade.id) &&
    researchedTechs.includes(upgrade.requires.tech)
  );

export default upgrades;
